import t from "react";
import { c as i, t as l } from "./app-a75c1d35.mjs";
import { i as Q } from "./Image.module-8b345b58.mjs";
import { B as r } from "./Block-9b78bd10.mjs";
const g = "article-quote", h = "article-quote__quote", q = "article-quote__name", E = "article-quote--lightBlue", L = "article-quote--lightGrey", y = "article-quote__vertical-credits", C = "article-quote__curtain-show", a = {
  articleQuote: g,
  articleQuoteQuote: h,
  articleQuoteName: q,
  articleQuoteLightBlue: E,
  articleQuoteLightGrey: L,
  articleQuoteVerticalCredits: y,
  articleQuoteCurtainShow: C
};
function x(e) {
  const { name: o, quote: u, variant: c, id: n, i18n: s } = e, { creditsLabel: m = "Credits" } = s ?? {}, d = c === "color" ? e.color === "lightGrey" ? a.articleQuoteLightGrey : a.articleQuoteLightBlue : void 0;
  return /* @__PURE__ */ t.createElement(
    r,
    {
      id: n,
      topPadding: r.Padding.LARGE,
      bottomPadding: r.Padding.LARGE,
      className: i(a.articleQuote, d),
      "data-testid": "article-quote"
    },
    c === "image" ? /* @__PURE__ */ t.createElement(N, { imageData: e.imageData }) : null,
    /* @__PURE__ */ t.createElement(r.Content, { style: { zIndex: 1 } }, /* @__PURE__ */ t.createElement(
      "blockquote",
      {
        className: i(l.headingSection, a.articleQuoteQuote)
      },
      u
    ), /* @__PURE__ */ t.createElement("p", { className: i(l.textsLeadText, a.articleQuoteName) }, o), c === "image" && e.credits ? /* @__PURE__ */ t.createElement(
      "p",
      {
        className: i(
          a.articleQuoteVerticalCredits,
          l.textsCaption
        )
      },
      m,
      ": ",
      e.credits
    ) : null)
  );
}
function N({
  imageData: e
}) {
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    "img",
    {
      src: e.imageLoader?.() || e.imageSrc,
      width: e.width,
      height: e.height,
      alt: "",
      "aria-hidden": "true",
      className: Q.imageArticleQuote
    }
  ), /* @__PURE__ */ t.createElement("div", { className: i(a.articleQuoteCurtainShow) }));
}
export {
  x as default
};
//# sourceMappingURL=ArticleQuote.js.map
